<template>
    <nord-modal
        :open="showModal"
        size="l"
        @close="closeModal"
    >
        <div class="video-modal-container" slot="feature">
            <button
                type="button"
                class="video-modal-close-btn"
                @click="closeModal"
                aria-label="Close video"
            >
                ×
            </button>
            <VideoPlayer
                v-if="videoUrl"
                :options="videoOptions"
                class="w-full"
            />
        </div>
    </nord-modal>
</template>

<script>
import VideoPlayer from '../apps/online_courses/VideoPlayer.vue';

export default {
    name: 'VideoModal',

    components: {
        VideoPlayer,
    },

    data() {
        return {
            showModal: false,
            videoUrl: '',
        };
    },

    computed: {
        videoOptions() {
            if (!this.videoUrl) {
                return {};
            }

            return {
                sources: [{
                    src: this.videoUrl,
                    type: this.getVideoType(this.videoUrl)
                }],
                fluid: true,
                responsive: true,
                controls: true,
                preload: 'metadata',
            };
        }
    },

    methods: {
        openVideoModal(url) {
            this.videoUrl = url;
            this.showModal = true;
        },

        closeModal() {
            this.showModal = false;
            this.$nextTick(() => {
                this.videoUrl = '';
            });
        },

        getVideoType(url) {
            const extension = url.split('.').pop().toLowerCase();
            const typeMap = {
                'mp4': 'video/mp4',
                'mov': 'video/quicktime',
                'ogg': 'video/ogg',
                'webm': 'video/webm'
            };
            return typeMap[extension] || 'video/mp4';
        }
    },

    mounted() {
        this.$event_bus.$on('openVideoModal', this.openVideoModal);
    },

    beforeUnmount() {
        this.$event_bus.$off('openVideoModal', this.openVideoModal);
    }
};
</script>

<style scoped>
.video-modal-container {
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000;
    position: relative;
    width: 100%;
}

.video-modal-close-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 10;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
}

.video-modal-close-btn:hover {
    background: rgba(0, 0, 0, 0.9);
}

.video-modal-close-btn:focus {
    outline: 2px solid #fff;
    outline-offset: 2px;
}
</style>
